// extracted by mini-css-extract-plugin
export default {"auditTable":"AuditEvents_auditTable__UY8Gu","center":"AuditEvents_center__UlbFM"};